<template>
  <section
    class="sec reveal"
    id="stories"
    data-ga-section="testimonials"
  >
    <div class="sec-head-row">
      <div>
        <span class="sec-eyebrow">{{ trans.get('landing.stories.eyebrow') }}</span>
        <h2 class="sec-title">
          {{ trans.get('landing.stories.title_line1') }}<br />
          <span class="grad">{{ trans.get('landing.stories.title_line2_grad') }}</span
          >{{ trans.get('landing.stories.title_line2_suffix') }}
        </h2>
      </div>
      <p class="sec-lede sec-lede--tight">{{ trans.get('landing.stories.lede') }}</p>
    </div>

    <div class="stories">
      <article
        v-for="card in cards"
        :key="card.key"
        class="story"
        :class="card.cls"
      >
        <span class="stat">{{ trans.get(card.statKey) }}</span>
        <div
          class="quote-mark"
          :class="card.quoteCls"
        >
          "
        </div>
        <p class="qt">{{ trans.get(card.quoteKey) }}</p>
        <div class="auth">
          <div
            class="av"
            :class="card.avCls"
          ></div>
          <div>
            <div class="nm">{{ trans.get(card.nameKey) }}</div>
            <div class="meta">{{ trans.get(card.metaKey) }}</div>
          </div>
        </div>
      </article>
    </div>

    <div class="stories-cta">
      <a
        href="stories"
        class="more-link"
        data-ga-content-link
        data-ga-section="testimonials"
        >{{ trans.get('landing.stories.more_link') }}</a
      >
    </div>
  </section>
</template>

<script>
export default {
  name: 'StoriesSection',
  data() {
    return {
      cards: [
        {
          key: 'c1',
          cls: 's1',
          quoteCls: '',
          avCls: 'av--mia',
          statKey: 'landing.stories.card1_stat',
          quoteKey: 'landing.stories.card1_quote',
          nameKey: 'landing.stories.card1_name',
          metaKey: 'landing.stories.card1_meta',
        },
        {
          key: 'c2',
          cls: 's2',
          quoteCls: 'quote-mark--pink',
          avCls: 'av--sophia',
          statKey: 'landing.stories.card2_stat',
          quoteKey: 'landing.stories.card2_quote',
          nameKey: 'landing.stories.card2_name',
          metaKey: 'landing.stories.card2_meta',
        },
        {
          key: 'c3',
          cls: 's4 story--wide',
          quoteCls: 'quote-mark--pink',
          avCls: 'av--anna',
          statKey: 'landing.stories.card3_stat',
          quoteKey: 'landing.stories.card3_quote',
          nameKey: 'landing.stories.card3_name',
          metaKey: 'landing.stories.card3_meta',
        },
      ],
    };
  },
};
</script>
<style scoped lang="scss">
.stories-cta {
  text-align: center;
  margin-top: 36px;
}

@media (max-width: 900px) {
  .stories {
    grid-template-columns: repeat(2, 1fr);
    padding: 0;
  }

  .story.s1,
  .story.s2,
  .story.s4 {
    grid-column: span 2;
    grid-row: auto;
  }
}
</style>
